import {ArrowPositionType} from '../types';

const padding = 14;

export const getArrowspacingHeight = (
  arrowPosition: ArrowPositionType,
  tooltipHeight: number,
) => {
  switch (arrowPosition) {
    case 'RightTop':
      return padding / 2;
    case 'RightCenter':
      return tooltipHeight / 2;
    case 'RightBottom':
      return tooltipHeight - padding / 2;
    case 'LeftTop':
      return padding / 2;
    case 'LeftCenter':
      return tooltipHeight / 2;
    case 'LeftBottom':
      return tooltipHeight - padding / 2;
    default:
      return undefined;
  }
};
